export const uk = {
    'page-common-error': 'Произошла ошибка',
    'page-common-error-hint': 'Обновите страницу либо попробуйте зайти позже',
    'save-campaigns-error':
        'При сохранении кампании произошли ошибки, попробуйте еще раз и в случае повторения ошибки обратитесь в службу поддержки.',
    'warning-about-changes': 'Изменения не будут сохранены, продолжить?'
};
